"use client"

import { useState, useEffect, useRef } from "react"
// Ajusta la ruta al CSS según tu estructura. Si Inicio.js está en src/components/
// y inicio.css está en src/components/css/, la ruta es correcta.
import "./css/inicio.css"

// Importa las imágenes desde la carpeta src/img/
// La ruta es relativa desde src/components/Inicio.js hasta src/img/
import portadaImg1 from "../img/portada.jpg"
import portadaImg2 from "../img/portada2.jpg"
import portadaImg3 from "../img/portada3.jpg"
import portadaImg4 from "../img/portada4.jpg"

const Inicio = () => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [touchStart, setTouchStart] = useState(null)
  const [touchEnd, setTouchEnd] = useState(null)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const sliderRef = useRef(null)

  // Usa las imágenes importadas
  const images = [
    { src: portadaImg1, alt: "Slide 1", clickable: false },
    { src: portadaImg4, alt: "Slide 2", clickable: false },
    { src: portadaImg3, alt: "Slide 3", clickable: false },
    {
      src: portadaImg2,
      alt: "Slide 4",
      clickable: true,
      link: "https://wa.me/50230544755?text=Hola%20escribo%20de%20la%20p%C3%A1gina%20web%20quiero%20m%C3%A1s%20informaci%C3%B3n",
    },
  ]

  // Distancia mínima para considerar un swipe
  const minSwipeDistance = 50

  // Cambio automático cada 20 segundos
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isTransitioning) {
        setCurrentSlide((prev) => (prev + 1) % images.length)
      }
    }, 20000)

    return () => clearInterval(interval)
  }, [images.length, isTransitioning])

  const goToSlide = (index) => {
    if (!isTransitioning) {
      setCurrentSlide(index)
    }
  }

  const handleImageClick = (image) => {
    if (image.clickable && image.link) {
      window.open(image.link, "_blank")
    }
  }

  // Funciones para manejar el touch/swipe
  const onTouchStart = (e) => {
    setTouchEnd(null) // Reset touchEnd
    setTouchStart(e.targetTouches[0].clientX)
  }

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX)
  }

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return

    const distance = touchStart - touchEnd
    const isLeftSwipe = distance > minSwipeDistance
    const isRightSwipe = distance < -minSwipeDistance

    if (isLeftSwipe || isRightSwipe) {
      setIsTransitioning(true)

      if (isLeftSwipe) {
        // Swipe izquierda - siguiente imagen
        setCurrentSlide((prev) => (prev + 1) % images.length)
      }

      if (isRightSwipe) {
        // Swipe derecha - imagen anterior
        setCurrentSlide((prev) => (prev - 1 + images.length) % images.length)
      }

      // Reset transition flag después de la animación
      setTimeout(() => {
        setIsTransitioning(false)
      }, 700) // Duración de la transición CSS
    }
  }

  return (
    <section className="slider-container" id="Inicio">
      <div className="slider-wrapper">
        <div
          className="slider-track"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          ref={sliderRef}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
          {images.map((image, index) => (
            <div key={index} className="slide">
              <img
                src={image.src || "/placeholder.svg"}
                alt={image.alt}
                className={`slide-image ${image.clickable ? "clickable-image" : ""}`}
                onClick={() => handleImageClick(image)}
                style={{ cursor: image.clickable ? "pointer" : "default" }}
                draggable={false} // Prevenir el drag nativo de las imágenes
              />
              {/* No hay contenido de texto aquí */}
            </div>
          ))}
        </div>

        {/* Indicadores */}
        <div className="indicators">
          {images.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentSlide ? "active" : ""}`}
              onClick={() => goToSlide(index)}
              aria-label={`Ir al slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Inicio
